import { commonStyles } from '../../styles';

export default () => ({
  ...commonStyles,
  loadingContainer: {
    margin: '2rem',
    textAlign: 'center',
  },
  activityContainer: { width: '100%' },
  header: { display: 'flex' },
  historyItemContainer: { cursor: 'pointer' },
});
